import { RoutePoint, RoutePointValue, MapName } from '../types';

import { MAP_NAMES } from '../constants';

export const createRoutePoint = (value: RoutePointValue = {}): RoutePoint => ({
  id: Math.random().toString(),
  value
});

export const checkIsGoogleMap = (mapName?: MapName) => (
  mapName === MAP_NAMES.google
);

export const checkIsHereMap = (mapName?: MapName) => (
  mapName === MAP_NAMES.here
);
